import { render } from "./account_bills.vue?vue&type=template&id=318db386"
import script from "./account_bills.vue?vue&type=script&lang=js"
export * from "./account_bills.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/Whisper/Development/projects/sid/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__